
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import AppSelectBankType from "@/components/bank/SelectBankType.vue";
import AppMultiSelectBankType from "@/components/bank/MultiSelectBankType.vue";
import { BankKind } from "@/models/base/bank";

export default Vue.extend({
	props: {
		value: {
			type: [String, Array as ()=>string[]],
			required: true
		},
		multi: Boolean,
		label: {
			type: [Object as ()=>TranslateResult, String],
			default():TranslateResult{
				if (this.multi) return this.$ct("bank-kinds");
				return this.$ct("bank-kind");
			}
		}
	},
	computed: {
		singleValue():BankKind | undefined {
			if (typeof(this.value) == "object"){
				return parseInt(this.value[0]);
			}
			return parseInt(this.value);
		},
		multiValue():number[]{
			if (typeof(this.value) == "string"){
				return [parseInt(this.value)];
			}
			return this.value.map(v=>{
				return parseInt(v);
			}).filter(v=>!Number.isNaN(v));
		}
	},
	methods: {
		setSingleValue(value:string){
			this.$emit("input", `${value}`);
		},
		setMultiValue(value:number[]){
			this.$emit("input", value.map(v=>`${v}`));
		}
	},
	components: {
		AppSelectBankType,
		AppMultiSelectBankType
	},
	i18nEx: {
		componentPrefix: "components.models"
	}
});
